import { Alert, Badge, ProgressBar, Collapse } from "react-bootstrap";
import { useState } from "react";

export default function ValidationSummarySection({
  report,
  isOpenByDefault = false,
}) {
  const [open, setOpen] = useState(isOpenByDefault);

  if (!report) return null;

  const {
    totalRequired,
    filledRequired,
    missingRequired,
    missingFields,
    isValid,
  } = report;

  const percent =
    totalRequired > 0
      ? Math.round((filledRequired / totalRequired) * 100)
      : 100;

  return (
    <div className="">
      {/* MAIN ROW */}
      <div className="d-flex align-items-center justify-content-between gap-3">
        {/* LEFT — STATUS */}
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Badge bg={isValid ? "success" : "danger"} pill>
            {isValid ? "Complete" : `${missingRequired} Missing`}
          </Badge>

          <small className="text-muted">
            {filledRequired}/{totalRequired} required filled
          </small>
        </div>

        {/* CENTER — PROGRESS */}
        <div style={{ flex: 1, maxWidth: 220 }}>
          <ProgressBar
            now={percent}
            style={{ height: 6 }}
            variant={isValid ? "success" : "warning"}
          />
        </div>

        {/* RIGHT — ACTION */}
        {!isValid && (
          <button
            className="btn btn-sm btn-link p-0 text-danger"
            onClick={() => setOpen(!open)}
          >
            {open ? "Hide" : "Details"}
          </button>
        )}
      </div>

      {/* DETAILS */}
      <Collapse in={open}>
        <div className="mt-2 border-top pt-2 small">
          {missingFields.map(f => (
            <div key={f.id} className="d-flex justify-content-between py-1">
              <span>{f.label || "Required field"}</span>
              <span className="text-muted">{f.type}</span>
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
}
